import React, { useState, useEffect } from 'react'

import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Menu,
  Checkbox,
  Table,
  Tag,
  Space,
  Radio,
  Divider,
  DatePicker,
  Result,
  Modal,
  InputNumber,
  Empty,
  notification,
  TimePicker,
} from 'antd'
import moment from 'moment'
const { RangePicker } = DatePicker
import dayjs from 'dayjs'
import { getCookie } from 'helper/cookie'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import 'styleLess/signature/sprintTaskFlow.scss'

import {
  getResultProjectList,
  postholiday,
  editTaskInformation,
  getResultAllSprintFlow,
  getChart,
  getResultSubTask,
  getFlowCheckDate,
  checkCompleteFlow,
} from 'api/Project/sprintFlow'

import { getProjectById } from 'api/Project/project'

import lang from 'lang/en'

import {
  getMemberAssignee,
  getPermissionAssignee,
  editPermissionAssignee,
} from 'api/Project/sprintFlow'
import { get } from 'lodash'

const Container = styled.div`
  background-color: white;
  height: auto;
  margin-top: 32px;

  .border {
    border-radius: 5px;
  }

  .fontradio {
    font-family: IBMPlexSansThaiRegular;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
  }
`

const initalState = {
  data: [],
  isLoading: true,
}

const format = 'HH:mm'

let taskDateStart = ''
let taskDateEnd = ''
let ArrayDate = []
let projectClosure = ''
let projectKickOff = ''
const AddTaskInformaion = (props) => {
  ///lang
  const language = getCookie('lang')
  const word = lang[language]
  // console.log(props)
  // console.log(ArrayDate)
  const {
    swithCaseTaskFLowFunction,
    role,
    idEditPRJ,
    GetName,
    checkDecision,
    checkPlandateTaskSubTask,
    checkChangeFlow,
    setCheckChangeFlow,
    fullyCheckComplete,
  } = props
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [form] = Form.useForm()

  /// holiday
  const [vishour, setVishour] = useState(true)
  const [plannedDateStart, setPlannedDateStart] = useState('')
  const [plannedDateEnd, setPlannedDateEnd] = useState('')
  const [dataHoliday, setDataHoliday] = useState(true)
  const [dataduration, setDataDuration] = useState()
  const [datatotalworkinghour, setDataTotalworkinghour] = useState('')
  const [dataworkingday, setDataWorkingday] = useState()

  ///task
  const { setSprintflowID } = props
  const [saveapi, setSaveapi] = useState(true)
  const [dataSprintTask, setDataSprintTask] = useState(initalState.data)
  const [idTask, setIDTask] = useState()

  ///email
  const [disableDays, setDisableDays] = useState(true)
  const [displayDays, setDisplayDays] = useState('none')
  const [disableDaysOndelay, setDisableDaysOndelay] = useState(true)
  const [displayDaysOndelay, setDisplayDaysOndelay] = useState('none')

  ///check date mandatory
  const [dataMandatory, setDataMandatory] = useState(initalState.data)
  const [checkStateMandatory, setCheckStateMandatory] = useState(false)

  ///check date closure
  const [dataHeader, setDataHeader] = useState({ closure: '', kickoff: '' })

  const [checkDisablePlanDate, setCheckDisablePlanDate] = useState(false)

  ///check shape task
  const [checkTaskType, setCheckTaskType] = useState()

  ///check btn save
  const [checkDisableDate, setCheckDisableDate] = useState(false)
  const [dateLimit, setDateLimit] = useState({ way: '', value2: '' })
  const [checkDateLimit, setCheckDateLimit] = useState()

  //checkbeforetask
  const [checkBeforeTask, setCheckBeforeTask] = useState(false)
  const [dateBeforeTask, setDateBeforeTask] = useState()

  //checkChangePlandate
  const [checkChangePlanDate, setCheckChangePlanDate] = useState(false)
  const [visibleModalCheckSubtask, setVisibleModalCheckSubtask] = useState(false)

  const [oldPlanDate, setOldPlanDate] = useState({ start: false, end: false })

  const [checkErrorPlan, setCheckErrorPlan] = useState('')

  const [dataMember, setDataMember] = useState(initalState.data)

  function disabledDate(current) {
    let st_date = ''
    let ed_date = ''

    let value = {
      id: dataSprintTask.id,
      plan_start: plannedDateStart,
      plan_end: plannedDateStart,
    }

    if (dateLimit.way == 'start') {
      return current >= moment(dateLimit.value2)
    } else if (dateLimit.way == 'end') {
      return current <= moment(dateLimit.value2)
    } else {
      if (dataMandatory.length >= 1) {
        if (dataMandatory[0]?.plan_start !== undefined && dataMandatory[0]?.plan_end) {
          st_date = dataMandatory[0]?.plan_start
          ed_date =
            dataMandatory[0].status == 'In Progress'
              ? '0000-01-01'
              : dataMandatory[0]?.plan_end
        }

        dataMandatory.map((item) => {
          const st_default = new Date(st_date)
          const ed_default = new Date(ed_date)
          const st_value = new Date(item.plan_start)
          const ed_value = new Date(
            item.status == 'In Progress' ? '0000-01-01' : item.plan_end,
          )
          if (st_value < st_default) {
            st_date = item.plan_start
          }

          if (ed_value > ed_default) {
            ed_date = item.status == 'In Progress' ? '0000-01-01' : item.plan_end
          }
        })

        if (selectRange == 'start') {
          // console.log(dataMandatory)
          return functioncheckMandatory(
            dataMandatory,
            //check empty range picker
            value.plan_start == ''
              ? current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure).add(1, 'days')
              : current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure),
            current,
            value,
          )
        } else {
          // console.log(st_date)
          return functioncheckMandatory(
            dataMandatory,
            //check empty range picker

            value.plan_start == ''
              ? current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure).add(1, 'days')
              : current < moment(dataHeader.kickoff) ||
                  current > moment(dataHeader.closure),
            current,
            value,
          )
        }
      } else {
        return functioncheckMandatory(
          dataMandatory,
          //check empty range picker
          value.plan_start
            ? current < moment(dataHeader.kickoff) || current > moment(dataHeader.closure)
            : current < moment(dataHeader.kickoff) ||
                current > moment(dataHeader.closure).add(1, 'days'),
          current,
          value,
        )
      }
    }
  }

  const functioncheckMandatory = (arrMandatory, lastcheck, current, value) => {
    let arrTrueFalseMandatory = []
    arrMandatory?.map((item) => {
      if (item.plan_start != null) {
        if (value.id != item.id) {
          arrTrueFalseMandatory.push(
            !(
              //check empty range picker
              (value.plan_start
                ? current < moment(item?.plan_start) || current > moment(item?.plan_end)
                : current < moment(item?.plan_start) ||
                  current > moment(item?.plan_end).add(1, 'days'))
            ),
          )
        }
      }
    })
    arrTrueFalseMandatory.push(lastcheck)

    let functionOR = false
    arrTrueFalseMandatory.map((item) => {
      if (item == true) {
        functionOR = true
      }
    })

    return functionOR
  }

  const getDataClosureDate = async () => {
    await getProjectById({
      id: idEditPRJ,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          projectKickOff = data.kickoff
          projectClosure = data.closure
          setDataHeader({ closure: data.closure, kickoff: data.kickoff })
          await setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const onChangePlanned = (value, dateString) => {
    let err = false

    // คำนวณความแตกต่างของวัน
    const start = dayjs(dateString[0])
    const end = dayjs(dateString[1])
    const difference = end.diff(start, 'day')
    dataMandatory?.map((m) => {
      let manStart = new Date(m.plan_start)
      let manEnd = new Date(m.plan_end)
      let defaultTask_start = new Date(dateString[0])
      let defaultTask_end = new Date(dateString[1])

      if (dataSprintTask.id != m.id) {
        if (defaultTask_start > manStart && defaultTask_end < manEnd) {
          // case ---- |start end|
          err = true
        } else if (defaultTask_start < manStart && defaultTask_end > manEnd) {
          //case ---- start| |end
          err = true
        } else if (
          defaultTask_start > manStart &&
          defaultTask_start < manEnd &&
          defaultTask_end > manEnd
        ) {
          //case ---- | start|end
          err = true
        } else if (
          defaultTask_start < manStart &&
          defaultTask_end > manStart &&
          defaultTask_end < manEnd
        ) {
          err = true
        }
      }
    })
    setCheckErrorPlan(err ? 'error' : '')

    setCheckDisableDate(false)
    // ดึงจำนวนชั่วโมงจาก moment workinghourperday
    const workingHours = moment('08:00', 'HH:mm').hours() // 8 ชั่วโมง
    const totalWorkingHour = `${(difference + 1) * workingHours}:00` // แสดงผลแบบ hh:mm
    form.setFieldsValue({
      duration: difference + 1,
      totalworkinghour: totalWorkingHour,
      workingday: difference + 1,
      workinghourperday: moment('08:00', 'HH:m'),
    })
    setDataDuration(form.getFieldValue('duration'))
    setDataWorkingday(form.getFieldValue('workingday'))
    setDataTotalworkinghour(form.getFieldValue('totalworkinghour'))
    if (value == null) {
      setVishour(true)
    } else {
      setVishour(false)
    }
    setPlannedDateStart(dateString[0])
    setPlannedDateEnd(dateString[1])
    CheckChangePlanned(dateString[0], dateString[1])
  }

  const onChangeWorkperD = async (values) => {
    let hours = moment(values, '00:00').format('HH:mm')
    CheckChange(values, 'workinghourperday')
    if (hours == '00:00') {
      form.setFieldsValue({
        duration: null,
        totalworkinghour: null,
        workingday: null,
      })
    } else {
      const dataArray = {
        project_id: parseInt(idEditPRJ),
        plan_start: plannedDateStart,
        plan_end: plannedDateEnd,
        working_hour: hours,
      }
      try {
        await postholiday({
          params: dataArray,
          token: token,
        }).then((response) => {
          const { status, data, error } = response

          if (error) {
            setDataHoliday([])
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            setDataHoliday(data)
            setIsLoading(false)

            form.setFieldsValue({
              duration: data.duration,
              totalworkinghour: data.working_hours,
              workingday: data.working_days,
            })
            setDataDuration(data.duration)
            setDataTotalworkinghour(data.working_hours)
            setDataWorkingday(data.working_days)
          } else {
            setDataHoliday([])
            setIsLoading(false)
            return true
          }
        })
      } catch (error) {
        setDataHoliday([])
        setIsLoading(false)
        console.log(error)
      }
    }
  }

  //check date mandatory
  const getSprintFlowTask = async (idd) => {
    ArrayDate = []
    getResultAllSprintFlow({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataMandatory([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          let arr = []
          data.map((item) => {
            if (idd !== item.id) {
              if (item.task_type == 'M') {
                const dataArray = {
                  id: item.id,
                  plan_start: item.plan_start,
                  plan_end: item.plan_end,
                  status: item.flow_status,
                }
                arr.push(dataArray)
                ArrayDate.push(dataArray)

                setCheckStateMandatory(true)
              }
            }
          })
          setDataMandatory(arr)
        } else {
          setDataMandatory([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataMandatory([])
        setIsLoading(false)
        console.error(error)
      })
  }

  ///check shape chart

  ///task
  const getDataSprintTask = async () => {
    await getResultProjectList({
      project_id: parseInt(idEditPRJ),
      id_chart: props.funcsetIdChart,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataSprintTask([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          // console.log(data.comment)
          getSprintFlowTask(data.id)
          setSaveapi(false)
          await setDataSprintTask(data)
          await setIsLoading(false)
          data.flow_status == 'In Progress'
            ? setCheckDisablePlanDate(true)
            : setCheckDisablePlanDate(false)
          form.setFieldsValue({
            name: data.title,
          })
          form.setFieldsValue({
            tasktype: 'Y',
          })
          if (data.ondelay == 0) {
            form.setFieldsValue({
              OndelaysCheckBox: '',
            })
          } else {
            setDisplayDaysOndelay('')
            form.setFieldsValue({
              OndelaysCheckBox: [0],
              daysOndelay: data.ondelay,
            })
          }

          if (data.shape_chart == 'flow-rhombus') {
            setCheckTaskType(true)
            form.setFieldsValue({
              tasktype: 'M',
              CommentsProds: 'Y',
            })
          } else {
            form.setFieldsValue({
              tasktype: 'O',
              CommentsProds: 'Y',
            })
          }
          setSprintflowID(data.id)
          setIDTask(data.id)
          if (data.plan_start == '') {
            setVishour(true)
          } else {
            setPlannedDateStart(data.plan_start)
            setPlannedDateEnd(data.plan_end)
            setDataDuration(data.duration)
            setDataTotalworkinghour(data.total_working)

            setDataWorkingday(data.working)
            setVishour(false)

            setIDTask(data.id)

            let a = data.email_noti.split(',')
            var result = a.map(function (x) {
              return parseInt(x, 10)
            })
            // console.log(data.plan_start, data.plan_end)
            if (data.plan_start == '0000-00-00') {
              form.setFieldsValue({
                planned: null,
              })
            } else {
              setOldPlanDate({ start: data.plan_start, end: data.plan_end })
              form.setFieldsValue({
                planned: [
                  moment(data.plan_start, 'YYYY-MM-DD'),
                  moment(data.plan_end, 'YYYY-MM-DD'),
                ],
                tasktype: data.task_type,
              })
            }

            if (data.working_hour == 0) {
              form.setFieldsValue({
                workinghourperday: null,
              })
            } else {
              form.setFieldsValue({
                workinghourperday: moment(`${data.working_hour}`, 'HH:m'),
              })
            }

            form.setFieldsValue({
              name: data.title,
              description: data.description,
              CommentsProds: data.comment,
              duration: data.duration,
              totalworkinghour: data.total_working,
              workingday: data.working,

              emailnotifi: result,
            })
            // console.log(data.email_day)
            if (data.email_day == 0) {
              form.setFieldsValue({
                days: data.null,
              })
            } else {
              form.setFieldsValue({
                days: data.email_day,
              })
            }

            if (
              data.email_noti === '' ||
              data.email_noti === NaN ||
              data.email_noti === 'NaN'
            ) {
            } else {
              a.map((item) => {
                if (item == '4') {
                  setDisableDays(false)
                  setDisplayDays('')
                }
              })
            }
          }
        } else {
          setDataSprintTask([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataSprintTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataChartforCheckBeforeTask = async () => {
    await getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          // await setDataClosure([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          // console.log(data)
          data.nodes.map((item) => {
            if (item.shape == 'flow-rhombus') {
              data.edges.map((item2) => {
                if (item2.source == item.id) {
                  if (item2.target == props.funcsetIdChart) {
                    getResultProjectList({
                      project_id: parseInt(idEditPRJ),
                      id_chart: item.id,
                      token: token,
                    })
                      .then(async (response) => {
                        const { status, data, error } = response

                        if (error) {
                          // await setDataClosure([])

                          await setIsLoading(false)
                          return true
                        }
                        if (status === 200) {
                          setCheckBeforeTask(true)
                          setDateBeforeTask(data.plan_end)
                          await setIsLoading(false)
                        } else {
                          // setDataClosure([])

                          setIsLoading(false)
                          return true
                        }
                      })
                      .catch((error) => {
                        // setDataClosure([])
                        setIsLoading(false)
                        console.error(error)
                      })
                  }
                }
              })
            }
          })
          await setIsLoading(false)
        } else {
          // setDataClosure([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        // setDataClosure([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataSprintTask()
      getDataClosureDate()
      getDataChartforCheckBeforeTask()
    }
  }, [token])

  const openNotificationWithIcon = (type) => {
    // console.log(dataPermission)

    notification[type]({
      message: 'Success',
      description: 'Information has been saved successfully.',
      duration: 3,
    })
  }

  const timeStamp = moment('08:00', 'HH:mm').format('HH:mm')

  const handleEditPermissionAssignee = (item) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: parseInt(idTask),
      account_id: item.account_id,
      permission: 5,
    }
    try {
      editPermissionAssignee({
        params: dataArray,
        token: token,
      }).then(async (response) => {
        const { status, data } = response
        if (status == 200) {
          return data
          // swithCaseTaskFLowFunction('')
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  // const getMemberData = async () => {
  //   await getMemberAssignee({
  //     sprintflow_id: parseInt(idTask),
  //     project_id: parseInt(idEditPRJ),
  //     token: token,
  //   })
  //     .then(async (response) => {
  //       const { status, data, error } = response
  //       if (error) {
  //         await setDataMember([])
  //         await setIsLoading(false)
  //         return true
  //       }
  //       if (status === 200) {
  //         if (data.member == null) {
  //           setDataMember([])
  //         } else {
  //           await setDataMember(data.member)
  //           data.member.map((item) => {
  //             if (item.permission == 0) {
  //               item.permission = 5
  //             }
  //             if (item.permission == 7) {
  //               handleEditPermissionAssignee(item)
  //             }
  //             if (item.role == 'Project Leader') {
  //               item.permission = 5
  //             }
  //             form.setFieldsValue({
  //               [item.firstname + item.role]: item.permission,
  //             })
  //           })
  //         }
  //         await setIsLoading(false)
  //       } else {
  //         setDataMember([])

  //         setIsLoading(false)
  //         return true
  //       }
  //     })
  //     .catch((error) => {
  //       setDataMember([])
  //       setIsLoading(false)
  //       console.error(error)
  //     })
  // }

  // useEffect(() => {
  //   if (token) {
  //     getMemberData()
  //   }
  // }, [token])

  const onFinish = (values) => {
    // getMemberData()
    if (values.emailnotifi == null) {
      values.emailnotifi = []
    }

    let emailnoti = values.emailnotifi.join(',')
    const dataArray = {
      id: parseInt(idTask),
      project_id: parseInt(idEditPRJ),
      title: values.name,
      id_chart: props.funcsetIdChart,
      description: values.description,
      plan_start: plannedDateStart,
      plan_end: plannedDateEnd,
      duration: dataduration,
      working: dataworkingday,
      working_hour: moment(values.workinghourperday, '08:00').format('HH:mm'),
      total_working: datatotalworkinghour,
      email_noti: emailnoti,
      email_day: parseInt(values.days),
      task_type: values.tasktype,
      ondelay: parseInt(values.daysOndelay),
      comment: values.CommentsProds,
      level: 1,
      level_id: 0,
    }

    try {
      editTaskInformation({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          // getMemberData()
          checkPlandateTaskSubTask()
          GetName()
          window.scrollTo(0, 0)
          props.setChangePageInformation(true)
          props.setChangePageInformation2(true)
          openNotificationWithIcon('success')
          getDataSprintTask()
          // swithCaseTaskFLowFunction('')
          const dataArrayCheckPlan = {
            project_id: parseInt(idEditPRJ),
            complete_flow: fullyCheckComplete,
          }
          try {
            checkCompleteFlow({
              params: dataArrayCheckPlan,
              token: token,
            }).then((response) => {
              const { status, data, error } = response
              if (status === 200) {
                // getChartData()
              }
            })
          } catch (error) {
            console.log(error)
          }
          if (checkChangePlanDate) {
            getResultSubTask({
              level_id: parseInt(idTask),
              project_id: parseInt(idEditPRJ),
              token: token,
            })
              .then(async (response) => {
                const { status, data, error } = response
                if (error) {
                  setIsLoading(false)
                  return true
                }
                if (status === 200) {
                  if (data.length > 0) {
                    // alert('change subtask')
                    // getMemberData()
                    getFlowCheckDate({
                      project_id: parseInt(idEditPRJ),
                      token: token,
                    })
                      .then(async (response) => {
                        const { status, data, error } = response

                        if (error) {
                          setIsLoading(false)
                          return true
                        }

                        let flowComplete = ''
                        if (data.err_check == 'Y' || fullyCheckComplete == 'N') {
                          setVisibleModalCheckSubtask(true)
                          setCheckChangeFlow('N')
                          flowComplete = 'N'
                        } else {
                          setCheckChangeFlow('Y')
                          flowComplete = 'Y'
                        }

                        const dataArray = {
                          project_id: parseInt(idEditPRJ),
                          complete_flow: flowComplete,
                        }

                        try {
                          checkCompleteFlow({
                            params: dataArray,
                            token: token,
                          }).then((response) => {
                            const { status, data, error } = response
                            if (status === 200) {
                              // getChartData()
                            }
                          })
                        } catch (error) {
                          console.log(error)
                        }

                        if (status === 200) {
                          setIsLoading(false)
                        } else {
                          setIsLoading(false)
                          return true
                        }
                      })
                      .catch((error) => {
                        setIsLoading(false)
                        console.error(error)
                      })
                  }
                  setIsLoading(false)
                } else {
                  setIsLoading(false)
                  return true
                }
              })
              .catch((error) => {
                setIsLoading(false)
                console.error(error)
              })
          }
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onChangeCheckBox = (e) => {
    if (e.target.checked == true) {
      CheckChange(e, 'beforeduedate')
      setDisableDays(false)
      setDisplayDays('')
    } else {
      CheckChange(e, 'beforeduedate2')
      form.setFieldsValue({
        days: null,
      })
      setDisableDays(true)
      setDisplayDays('none')
    }
  }

  const checkruledays = (values) => {
    if (role == true) {
      return (
        // <div style={{ display: displayDays }}>
        <Form.Item name="days">
          <Input
            disabled
            type="number"
            className="border"
            placeholder="Days"
            size="large"
            min={1}
            style={{ width: 140 }}
          ></Input>
        </Form.Item>
        // </div>
      )
    } else {
      if (values == false) {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item
            name="days"
            rules={[
              {
                required: true,
                message: word['addsubtask_information_Email_Days'],
              },
            ]}
          >
            <Input
              id="days"
              disabled={disableDays}
              onChange={(e) => CheckChange(e, 'Days')}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      } else {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item name="days">
            <Input
              disabled={disableDays}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      }
    }
  }

  const onChangeCheckBoxOndelay = (e) => {
    if (e.target.checked == true) {
      CheckChange(e, 'Ondelay')
      setDisableDaysOndelay(false)
      setDisplayDaysOndelay('')
    } else {
      CheckChange(e, 'Ondelay2')
      form.setFieldsValue({
        daysOndelay: null,
      })
      setDisableDaysOndelay(true)
      setDisplayDaysOndelay('none')
    }
  }

  const checkruledaysOndelay = (values) => {
    if (role == true) {
      return (
        // <div style={{ display: displayDays }}>
        <Form.Item name="daysOndelay">
          <Input
            disabled
            type="number"
            className="border"
            placeholder="Days"
            size="large"
            min={1}
            style={{ width: 140 }}
          ></Input>
        </Form.Item>
        // </div>
      )
    } else {
      if (values == false) {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item
            name="daysOndelay"
            rules={[
              {
                required: true,
                message: word['addsubtask_information_ondelay_Days'],
              },
            ]}
          >
            <Input
              id="daysOndelay"
              disabled={disableDaysOndelay}
              onChange={(e) => CheckChange(e, 'OndelayDays')}
              type="number"
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      } else {
        return (
          // <div style={{ display: displayDays }}>
          <Form.Item name="daysOndelay">
            <Input
              type="number"
              onChange={(e) => CheckChange(e, 'OndelayDays')}
              className="border"
              placeholder="Days"
              size="large"
              min={1}
              style={{ width: 140 }}
            ></Input>
          </Form.Item>
          // </div>
        )
      }
    }
  }
  const CheckChange = (e, type) => {
    if (type == 'Title') {
      if (dataSprintTask.title !== e.target.value) {
        props.setChangePageInformation(false)
        console.log('title change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'Description') {
      if (dataSprintTask.description == undefined) {
        dataSprintTask.description = ''
      }
      if (dataSprintTask.description !== e.target.value) {
        props.setChangePageInformation(false)
        console.log('description change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'workinghourperday') {
      // console.log(dataSprintTask.working_hour)
      // console.log(e)
      if (dataSprintTask.working_hour !== e) {
        props.setChangePageInformation(false)
        console.log('workinghourperday change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'tasktype') {
      if (dataSprintTask.task_type == '') {
        dataSprintTask.task_type = 'O'
      }
      if (dataSprintTask.task_type !== e.target.value) {
        props.setChangePageInformation(false)
        console.log('tasktype change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'CommentsProds') {
      // console.log(dataSprintTask.comment, e.target.value)

      if (dataSprintTask.comment == '') {
        dataSprintTask.comment = 'Y'
      }
      if (dataSprintTask.comment !== e.target.value) {
        props.setChangePageInformation(false)
        console.log('CommentsProds change')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'emailnotifi') {
      let a = dataSprintTask.email_noti.split(',')
      var result = a.map(function (x) {
        return parseInt(x, 10)
      })
      if (result == 'NaN') {
        result = []
      }
      // console.log(result)
      // console.log(e)
      if (result.length == 4) {
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        // console.log(checkemail, result.length)
        if (checkemail != result.length) {
          props.setChangePageInformation(false)
          console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      } else if (result.length == 0) {
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        // console.log(result.length, e.length)
        if (e.length != result.length) {
          props.setChangePageInformation(false)
          console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      } else {
        console.log('1-3')
        let checkemail = 0
        result.map((item) => {
          e.map((item2) => {
            // console.log(item, item2)
            if (item == item2) {
              checkemail = checkemail + 1
            }
          })
        })
        if (checkemail != result.length || e.length != result.length) {
          props.setChangePageInformation(false)
          console.log('change checkbox email')
        } else {
          props.setChangePageInformation(true)
        }
      }
    } else if (type == 'Days') {
      if (dataSprintTask.email_day == undefined) {
        dataSprintTask.email_day = ''
      }
      if (dataSprintTask.email_day != e.target.value) {
        props.setChangePageInformation(false)
        console.log('Days change')
      } else {
        props.setChangePageInformation2(true)
        props.setChangePageInformation(true)
      }
    } else if (type == 'OndelaysCheckBox2') {
      let checkboxdefault = false

      if (dataSprintTask.ondelay == 0) {
        checkboxdefault = false
      } else {
        checkboxdefault = true
      }

      let checkbox = false
      if (e.length == 0) {
        checkbox = false
      } else {
        checkbox = true
      }

      if (checkboxdefault != checkbox) {
        props.setChangePageInformation(false)
        console.log('OndelaysCheckBox')
      } else {
        props.setChangePageInformation(true)
      }
    } else if (type == 'OndelayDays') {
      // console.log(dataSprintTask.ondelay, e.target.value)
      if (dataSprintTask.ondelay != parseInt(e.target.value)) {
        props.setChangePageInformation(false)
        console.log('Ondelay Days change')
      } else {
        props.setChangePageInformation2(true)
        props.setChangePageInformation(true)
      }
    } else if (type == 'Ondelay') {
      props.setChangePageInformation2(false)
      console.log('change Ondelay')
    } else if (type == 'Ondelay2') {
      props.setChangePageInformation2(true)
    } else if (type == 'beforeduedate') {
      props.setChangePageInformation2(false)
      console.log('change beforeduedate')
    } else if (type == 'beforeduedate2') {
      props.setChangePageInformation2(true)
    }
  }

  const CheckChangePlanned = (dateStart, dateEnd) => {
    if (dataSprintTask.plan_start !== dateStart) {
      setCheckChangePlanDate(true)
      console.log('planStart change')
      props.setChangePageInformation(false)
    } else if (dataSprintTask.plan_end !== dateEnd) {
      setCheckChangePlanDate(true)
      console.log('planEnd change')
      props.setChangePageInformation(false)
    } else {
      setCheckChangePlanDate(false)
      props.setChangePageInformation(true)
    }
  }

  const onPanelChange = (e, dateString) => {
    if (dateString !== null) {
      if (dataMandatory.length > 0) {
        if (selectRange == 'start') {
          let st_date = moment(dataHeader.closure).add(1, 'days').format('YYYY-MM-DD')
          dataMandatory.map((item) => {
            const st_default = new Date(st_date)
            const st_value = new Date(item.plan_start)
            const selectDate = new Date(dateString[0])
            if (st_value >= selectDate) {
              if (st_value < st_default) {
                st_date = item.plan_start
              }
            }
          })
          setDateLimit({ way: 'start', value2: st_date })
        } else {
          // check empty rang picker
          let st_date = plannedDateStart
            ? moment(dataHeader.kickoff).add(-1, 'days').format('YYYY-MM-DD')
            : moment(dataHeader.kickoff).format('YYYY-MM-DD')
          dataMandatory.map((item) => {
            const st_default = new Date(st_date)
            const st_value = new Date(item.plan_end)
            const selectDate = new Date(dateString[1])
            if (st_value <= selectDate) {
              if (st_value > st_default) {
                //check empty range picker
                st_date = plannedDateStart
                  ? item.plan_end
                  : moment(item.plan_end).add(1, 'days').format('YYYY-MM-DD')
              }
            }
          })
          setDateLimit({ way: 'end', value2: st_date })
        }
      }
    }
  }

  const onBlur = (e) => {
    if (e.target.value) {
    } else {
      setDateLimit({ way: '' })
    }
  }

  const onOpenChange = (e) => {
    if (e == true) {
      // setCheckErrorPlan('none')
      setDateLimit({ way: '' })
      if (checkDisablePlanDate) {
        form.setFieldsValue({
          planned: [moment(plannedDateStart, 'YYYY-MM-DD'), null],
        })
      } else {
        // form.setFieldsValue({
        //   planned: null,
        // })
        // setPlannedDateStart('')
        // setPlannedDateEnd('')
      }
    } else {
      // if (plannedDateStart == '' && plannedDateEnd == '') {
      //   if (oldPlanDate.start != false) {
      //     form.setFieldsValue({
      //       planned: [
      //         moment(oldPlanDate.start, 'YYYY-MM-DD'),
      //         moment(oldPlanDate.end, 'YYYY-MM-DD'),
      //       ],
      //     })
      //   }
      // }
    }
  }

  let disable = false
  if (role == true) {
    disable = true
  } else {
    disable = false
  }

  const [selectRange, setSelectRange] = useState(false)
  const CalendarWay = (val) => {
    if (val.target.placeholder == 'Start date') {
      setSelectRange('start')
    } else {
      setSelectRange('end')
    }
  }

  return (
    <Container className="disable-page">
      <Form form={form} name="addtaskinformation" onFinish={onFinish}>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <h4 className="label">{word['addtask_information_title_name']}</h4>
              <Form.Item
                name="name"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: word['addtask_information_Name'],
                  },
                ]}
              >
                <Input
                  disabled={disable}
                  id="name"
                  onChange={(e) => CheckChange(e, 'Title')}
                  className="border"
                  placeholder="Name"
                  size="large"
                ></Input>
              </Form.Item>

              <h4 className="label">{word['addtask_information_title_deliverable']}</h4>
              <Form.Item name="description">
                <Input
                  disabled={disable}
                  id="description"
                  onChange={(e) => CheckChange(e, 'Description')}
                  className="border"
                  placeholder="Enter Deliverable"
                  size="large"
                ></Input>
              </Form.Item>
              <Row span={24}>
                <Col span={12} style={{ paddingRight: 16 }}>
                  <h4 className="label">{word['addtask_information_title_planned']}</h4>
                  <Form.Item
                    name="planned"
                    rules={[
                      {
                        required: true,
                        message: word['addtask_information_Planned'],
                      },
                    ]}
                  >
                    <RangePicker
                      id="Planned"
                      disabled={checkDisablePlanDate ? [true, false] : disable}
                      onCalendarChange={onPanelChange}
                      onOpenChange={onOpenChange}
                      onBlur={onBlur}
                      onFocus={(e) => CalendarWay(e)}
                      disabledDate={(e) => disabledDate(e, checkDisableDate)}
                      className="border"
                      style={{
                        width: '100%',
                        border: checkErrorPlan == 'error' ? '1px solid #ff6258' : '',
                      }}
                      onChange={onChangePlanned}
                      format="YYYY-MM-DD"
                      size="large"
                    />

                    {/* <RangePicker
                      disabled={[item.disabled_start, item.disabled_end]}
                      onCalendarChange={(e) => onChangeDateTask(e, item)}
                      onOpenChange={(e) => onOpenChange(e, item)}
                      onBlur={onBlur}
                      onFocus={(e) => CalendarWay(e)}
                      disabledDate={(e) => disableDateTask(e, item)}
                      size="large"
                      style={{ marginRight: 8 }}
                      onChange={(e) => onChangeTaskProject(e, item)}
                      value={[
                        item.plan_start === null ? null : moment(item.plan_start),
                        item.plan_end === null ? null : moment(item.plan_end),
                      ]}
                      allowClear={false}
                    /> */}
                  </Form.Item>

                  <h4 className="label">{word['addtask_information_title_duration']}</h4>
                  <Form.Item name="duration">
                    <Input
                      disabled={true}
                      id="duration"
                      className="border"
                      placeholder="Duration (Days)"
                      size="large"
                    ></Input>
                  </Form.Item>

                  <h4 className="label">
                    {word['addtask_information_title_totalworkinghour']}
                  </h4>
                  <Form.Item name="totalworkinghour">
                    <Input
                      disabled={true}
                      id="totalworkinghour"
                      className="border"
                      placeholder="Total Working Hour"
                      size="large"
                    ></Input>
                  </Form.Item>
                  <p style={{ color: '#FFAF00', marginTop: -20, marginBottom: 20 }}>
                    {datatotalworkinghour == 0 && dataworkingday == 0
                      ? '* Start/end date is holiday ,Working days equal to 0 days.'
                      : ''}
                  </p>
                </Col>
                <Col span={12} style={{ paddingLeft: 16 }}>
                  <h4 className="label">
                    {word['addtask_information_title_workinghourperday']}
                  </h4>
                  <Form.Item
                    name="workinghourperday"
                    rules={[
                      {
                        required: false,
                        message: word['addtask_information_Working_hours_per_day'],
                      },
                    ]}
                  >
                    {/* <Input
                      id="workinghourperday"
                      type="number"
                      className="border"
                      placeholder="Working hours per day"
                      disabled={role ? true : vishour}
                      min={1}
                      max={24}
                      onChange={(e) => onChangeWorkperD(e.target.value)}
                      size="large"
                      style={{ width: '100%' }}
                    ></Input> */}
                    <TimePicker
                      id="working_hours"
                      placeholder="Working hours per day"
                      defaultValue={moment(timeStamp, 'HH:mm')}
                      disabled={role ? true : vishour}
                      onOk={(e) => onChangeWorkperD(e)}
                      size="large"
                      style={{ width: '100%' }}
                      format={format}
                      showNow={false}
                      // onOk={onchangeTime}
                    />
                  </Form.Item>

                  <h4 className="label">
                    {word['addtask_information_title_workingday']}
                  </h4>
                  <Form.Item name="workingday">
                    <Input
                      id="workingday"
                      className="border"
                      placeholder="Working day (Days) "
                      disabled
                      size="large"
                    ></Input>
                  </Form.Item>

                  <Row>
                    <div>
                      <h4 className="label">
                        {word['addtask_information_title_comments']}
                      </h4>
                      <Form.Item
                        name="CommentsProds"
                        onChange={(e) => CheckChange(e, 'CommentsProds')}
                        rules={[
                          {
                            required: true,
                            message: word['addtask_information_Comments/Prods'],
                          },
                        ]}
                      >
                        <Radio.Group disabled={disable} id="Comments/Prods">
                          <Radio className="fontradio" value={'Y'}>
                            {word['addtask_information_value_comments_yes']}
                          </Radio>
                          <Radio className="fontradio" value={'N'}>
                            {word['addtask_information_value_comments_no']}
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </Row>
                </Col>
                <div hidden={checkDecision}>
                  <h4 className="label">{word['addtask_information_title_tasktype']}</h4>
                  <Form.Item
                    name="tasktype"
                    rules={[
                      {
                        required: true,
                        message: word['addtask_information_TaskType'],
                      },
                    ]}
                  >
                    <Radio.Group
                      id="tasktype"
                      disabled={role ? true : checkTaskType}
                      onChange={(e) => CheckChange(e, 'tasktype')}
                    >
                      <Radio className="fontradio" value={'M'}>
                        {word['addtask_information_value_tasktype_mandatory']}
                      </Radio>
                      <Radio className="fontradio" value={'O'}>
                        {word['addtask_information_value_tasktype_optional']}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Row>
            </Col>
          </Row>

          <Col
            span={24}
            style={{
              // paddingLeft: 16,
              paddingRight: 16,
              paddingTop: 16,
              paddingBottom: 16,
            }}
          >
            <Row>
              <Col span={19} style={{ marginTop: 8 }}>
                <Row>
                  <h2>{word['addtask_information_title_emailnoti']}</h2>
                </Row>
              </Col>
            </Row>
            <Row className="nomarginform">
              <Form.Item name="emailnotifi" className="formCheckboxEmail">
                <Checkbox.Group
                  className="CheckboxGroupArea"
                  disabled={disable}
                  id="emailnotifi"
                  style={{}}
                  onChange={(e) => CheckChange(e, 'emailnotifi')}
                >
                  <div className="checkboxarea">
                    <Checkbox className="fontradio" value={1}>
                      {word['addtask_information_value_emailnoti_start']}
                    </Checkbox>
                  </div>
                  <div className="checkboxarea">
                    <Checkbox className="fontradio" value={2}>
                      {word['addtask_information_value_emailnoti_end']}
                    </Checkbox>
                  </div>
                  <div className="checkboxarea">
                    <Checkbox className="fontradio" value={3}>
                      {word['addtask_information_value_emailnoti_update']}
                    </Checkbox>
                  </div>
                  <div className="checkboxarea">
                    <Checkbox className="fontradio" value={4} onChange={onChangeCheckBox}>
                      {word['addtask_information_value_emailnoti_beforedue']}
                    </Checkbox>
                  </div>
                </Checkbox.Group>
              </Form.Item>

              <Row
                style={{
                  display: displayDays,
                }}
                className="InputDays"
              >
                {checkruledays(disableDays)}

                <h4 style={{ marginLeft: 8 }}>
                  {word['addtask_information_unit_beforedue']}
                </h4>
              </Row>
            </Row>

            <Row style={{ marginTop: 8 }} className="nomarginform">
              <Form.Item name="OndelaysCheckBox" className="formCheckboxEmail">
                <Checkbox.Group
                  className="CheckboxGroupArea"
                  disabled={disable}
                  id="OndelaysCheckBox"
                  style={{ display: 'flex', flexDirection: 'row' }}
                  onChange={(e) => CheckChange(e, 'OndelaysCheckBox2')}
                >
                  <div className="checkboxarea">
                    <Checkbox
                      value={0}
                      className="fontradio"
                      onChange={onChangeCheckBoxOndelay}
                    >
                      {word['addtask_information_value_emailnoti_delays']}
                    </Checkbox>
                  </div>
                </Checkbox.Group>
              </Form.Item>

              <Row
                style={{
                  display: displayDaysOndelay,
                }}
                className="InputDays"
              >
                {checkruledaysOndelay(disableDaysOndelay)}

                <h4 style={{ marginLeft: 8 }}>
                  {word['addtask_information_unit_emailnoti_delays']}
                </h4>
              </Row>
            </Row>
          </Col>

          <Row justify="end" style={{ marginTop: 48 }}>
            <Button
              id="Next"
              className="BTN_Next"
              htmlType="submit"
              disabled={checkErrorPlan == 'error' ? true : false}
            >
              {word['addtask_information_btn_save']}
            </Button>
          </Row>
        </Col>
      </Form>

      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalCheckSubtask}
        okText={'Close'}
        onOk={() => setVisibleModalCheckSubtask(false)}
        onCancel={() => setVisibleModalCheckSubtask(false)}
        cancelButtonProps={{ hidden: true }}
        destroyOnClose
      >
        <ExclamationCircleOutlined className="exclamationCircleOutlined" />
        <h2>Please change plan date of sub task.</h2>
        <h4>The subtask date must be in the range of the task.</h4>
      </Modal>
    </Container>
  )
}
export default AddTaskInformaion
